import { createIsomorphicFn } from "@tanstack/react-start";
import { readMenu } from "@/api/vendure/menu/menu.query.options";
import type { DeliveryMethod } from "@/api/vendure/merchant/merchant.types";
import { DELIVERY_METHOD_TYPE } from "@/api/vendure/merchant/merchant.types";
import { buildMenuJsonLd } from "@/lib/seo";
import type { JsonLd } from "@/lib/seo.types";

const buildMenuJsonLdFromVendure = async (
  token: string,
  method: DeliveryMethod,
  currency: string,
): Promise<JsonLd | undefined> => {
  const categories = await readMenu({
    token,
    type: DELIVERY_METHOD_TYPE[method],
  });
  return categories.length > 0
    ? buildMenuJsonLd(categories, currency)
    : undefined;
};

const menuJsonLdLoadsInFlight = new Map<string, Promise<JsonLd | undefined>>();

export const readMenuJsonLdOnServer = createIsomorphicFn()
  .server(
    (
      token: string,
      method: DeliveryMethod,
      currency: string,
    ): Promise<JsonLd | undefined> => {
      const key = `${token}:${method}:${currency}`;
      const loadInFlight = menuJsonLdLoadsInFlight.get(key);
      if (loadInFlight) return loadInFlight;
      const load = buildMenuJsonLdFromVendure(token, method, currency).finally(
        () => menuJsonLdLoadsInFlight.delete(key),
      );
      menuJsonLdLoadsInFlight.set(key, load);
      return load;
    },
  )
  .client(async (): Promise<JsonLd | undefined> => undefined);
